import * as z from 'zod';

export const providerImportModalPayloadSchema = z.object({
  jobId: z.string().min(1),
});

export type ProviderImportModalPayload = z.infer<typeof providerImportModalPayloadSchema>;
